<div class="rrhh-remove-team-container">
  <h3 class="heading-02-semi-bold" *ngIf="value">
    ¿Desea dar de baja de QR al team de {{ value.teamLeader }}?
  </h3>
  <div class="date">
    <span class="subheading-01-semi-bold">Fecha de baja</span>
    <qr-date-picker
      class="date-picker"
      [config]="datePickerEmpty"
      (datepickerChange)="datepickerChange($event)"
      [hasError]="this.inputDatePickerHasError"
    ></qr-date-picker>
  </div>

  <ng-container *ngIf="this.value.agents.length > 0">
    <h4 class="subheading-01-semi-bold">
      Debe reasignar el tipo de agente para los miembros del team
    </h4>
    <div class="row" *ngFor="let agent of this.value.agents">
      <div>
        <p>{{ agent.name + " " + agent.lastName }}</p>
      </div>
      <div class="dropdown">
        <qr-dropdown
          id="split-dropdown"
          *ifNodeShow="[NODE_DO]"
          [config]="this.dropdownAgensLevelToBeDeleted"
          (change)="changeAgentLevelType($event, agent.id)"
          [selected]="MAP_REVERSE[agent.agentLevelType]"
          [hasError]="!agent.agentLevelType"
        ></qr-dropdown>
        <qr-dropdown
          [config]="this.dropdownAgensToBeDeleted"
          (change)="changeAgentType($event, agent.id)"
          [selected]="agent.agentType"
          [hasError]="!agent.agentType"
        ></qr-dropdown>
      </div>
    </div>
  </ng-container>
</div>
